export const LIGHT_COLOR = "#0086FF"; // #3AC6A3
export const LIGHT_GREEN = "#09B98D";
export const MAIN_COLOR_3 = "#07A58E";
export const MAIN_COLOR_2 = "#09B98D";
export const MAIN_COLOR = "#0044FF";
export const PENDING_CLASS_COLOR = "rgba(9, 185, 141, 0.5)";
export const CONFIRMED_CLASS_COLOR = "#09B98D";
export const PAST_CLASS_COLOR = "rgba(0, 0, 0, 0.5)";
export const CANCEL_CLASS_COLOR = "rgba(255, 0, 0, 1)";
